import React, { Component } from 'react'
import { Alert, Modal } from 'react-bootstrap'
import styles from './Existing.css'

class SuccessfulModal extends Component {

  render () {
    return (
      <Modal style={{top: '85px'}} show={this.props.show}>
        <Modal.Body style={{padding: '45px'}} className='text-center'>
          <div className='bottom30'>
            <img src={require('assets/images/success.png')} />
          </div>

          <div className={`${styles['modal-title']} bottom20`}>
            Congratulations!<br />
            Your Loyalty Program is now Activated
          </div>

          <div className={`${styles['modal-content']} bottom40`}>
            Your Loyalty Program will be implemented to all outlets, and will<br />
            be applied immediately for all transactions. Please make sure all<br />
            of your customers and outlets are aware of this program.<br />
            <br />
            <Alert bsStyle='warning' className={styles['warning-container']}>
              <div><i className={`fa fa-info-circle fa-2x ${styles['warning-icon']}`} /></div>
              <div>
                <span className={styles['warning-header']}>Please make sure you are running Moka app latest version.<br /></span>
                <span>Loyalty Program can only be used with minimum Moka App v7.0 (android tablet) or v12.8 (iOS)</span>
              </div>
            </Alert>
          </div>

          <div className='row'>
            <div className='col-md-12'>
              <button
                onClick={this._onClickClose}
                className={`btn btn-default btn-lg btn-block ${styles['modal-close-button']}`}
              >
                Close
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    )
  }

  _onClickClose = (e) => {
    e.stopPropagation()
    this.props.close()
  }
}

export default SuccessfulModal



// WEBPACK FOOTER //
// ./app/pages/Customers/Loyalty/Existing/SuccessfulModal.js